import { TCurrency } from '@/types';

const currencyToLocaleMap: Record<TCurrency, string> = {
  USD: 'en-US',
  EUR: 'de-DE',
  RSD: 'sr-RS',
  GBP: 'en-GB',
};

export const getCurrencyFormatter = (
  value: number,
  currency: TCurrency = 'EUR'
) => {
  const locale = currencyToLocaleMap[currency];

  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    currencyDisplay: 'symbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  });

  return formatter.format(value);
};
